import { useEffect, useId, useRef, useState, type FormEvent } from 'react';
import { api, ApiError, type CustomerDuplicateProbe } from '../api';
import { HIZLI_METIN } from '../metin/hizliTeklif';

const M = HIZLI_METIN.musteriForm;

export function MusteriEkleModal({ ad, kapat, sec }: { ad: string; kapat: () => void; sec: (id: string) => void }) {
  const parcalar = ad.split(/\s+/);
  const [firstName, setFirstName] = useState(parcalar.length > 1 ? parcalar.slice(0, -1).join(' ') : ad);
  const [lastName, setLastName] = useState(parcalar.length > 1 ? parcalar.at(-1)! : '');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [billingAddress, setBillingAddress] = useState('');
  const [nationalId, setNationalId] = useState('');
  const [busy, setBusy] = useState(false);
  const busyRef = useRef(false);
  const [error, setError] = useState<string | null>(null);
  const [duplicates, setDuplicates] = useState<CustomerDuplicateProbe | null>(null);
  const dialog = useRef<HTMLDialogElement>(null);
  const title = useId();
  useEffect(() => {
    const el = dialog.current;
    const trigger = document.activeElement as HTMLElement | null;
    el?.showModal();
    return () => { el?.close(); trigger?.focus(); };
  }, []);

  async function kaydet(event: FormEvent) {
    event.preventDefault();
    if (busyRef.current || !firstName.trim() || !lastName.trim() || !phone.trim()) return;
    busyRef.current = true; setBusy(true); setError(null); setDuplicates(null);
    const iletisim = { phone: phone.trim(), email: email.trim() || undefined };
    try {
      let bulunan: CustomerDuplicateProbe;
      try { bulunan = await api.findDuplicateCustomers(iletisim); }
      catch { setError(M.denetimHata); return; }
      if (bulunan.matches.length > 0) { setDuplicates(bulunan); return; }
      const created = await api.createCustomer({ type: 'INDIVIDUAL', firstName: firstName.trim(), lastName: lastName.trim(), ...iletisim, billingAddress: billingAddress.trim() || undefined, nationalId: nationalId.trim() || undefined });
      sec(created.id);
    } catch (caught) {
      if (caught instanceof ApiError && caught.status === 409) {
        const bulunan = await api.findDuplicateCustomers(iletisim).catch(() => null);
        if (bulunan !== null && bulunan.matches.length > 0) setDuplicates(bulunan);
        else setError(M.mukerrer);
      } else setError(M.hata);
    } finally { busyRef.current = false; setBusy(false); }
  }

  return <dialog ref={dialog} className="ht-musteri-modal" aria-labelledby={title} onCancel={(e) => { e.preventDefault(); if (!busyRef.current) kapat(); }}>
    <h2 id={title}>{M.baslik}</h2>
    <form onSubmit={(event) => void kaydet(event)}>
      <fieldset disabled={busy}>
        <label>{M.ad}<input autoFocus required maxLength={80} autoComplete="given-name" value={firstName} onChange={(e) => setFirstName(e.target.value)} /></label>
        <label>{M.soyad}<input required maxLength={80} autoComplete="family-name" value={lastName} onChange={(e) => setLastName(e.target.value)} /></label>
        <label>{M.telefon}<input required type="tel" maxLength={32} autoComplete="tel" value={phone} onChange={(e) => { setPhone(e.target.value); setDuplicates(null); }} /></label>
        <label>{M.eposta}<input type="email" maxLength={320} autoComplete="email" value={email} onChange={(e) => { setEmail(e.target.value); setDuplicates(null); }} /></label>
        <label className="ht-musteri-modal-tam">{M.adres}<input maxLength={140} autoComplete="street-address" value={billingAddress} onChange={(e) => setBillingAddress(e.target.value)} /></label>
        <label className="ht-musteri-modal-tam">{M.kimlik}<input inputMode="numeric" pattern="[1-9][0-9]{10}" maxLength={11} value={nationalId} onChange={(e) => setNationalId(e.target.value)} /></label>
      </fieldset>
      {error !== null ? <p role="alert" className="ht-hata-yazi">{error}</p> : null}
      {duplicates !== null ? <div role="alert"><p>{M.mukerrer}</p><ul>{duplicates.matches.map((c) => <li key={c.id}><button type="button" disabled={busy} onClick={() => sec(c.id)}>{c.displayName}</button></li>)}</ul></div> : null}
      <div className="ht-musteri-modal-eylem"><button type="button" disabled={busy} onClick={kapat}>{M.vazgec}</button><button type="submit" disabled={busy}>{busy ? M.bekle : M.kaydet}</button></div>
    </form>
  </dialog>;
}
